import { render, staticRenderFns } from "./cmpdescontotitulo.vue?vue&type=template&id=7d18c990&"
import script from "./cmpdescontotitulo.vue?vue&type=script&lang=js&"
export * from "./cmpdescontotitulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports